import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaXmark, FaPen } from "react-icons/fa6";
import Group from "@ltypes/group";
import Product from "@ltypes/product";
import Badge from "@components/ui/Badge/Badge";
import "./GroupList.scss";

type GroupListProps = {
    product: Product
    newId?: string,
    onDelete: (group: Group) => void,
    onUpdate: (group: Group) => void,
};

function GroupList(props: GroupListProps) {

    const { t } = useTranslation();

    const getRepeatLabel = (days: Array<number>): string => {
        const daysOfWeek: Array<string> = t('date.daysOfWeek', { returnObjects: true });
        
        let label: string = '';
        const listDays: Array<number> = days.map(Number);

        if(listDays.length === 7) {
            label = t('page.groups.all_days');
        }
        else if(listDays.length <= 2) {
            label = listDays.map(d => daysOfWeek[d]).join(', ');
        }
        else {
            let isNearDays: boolean = true;
            let prevDay: number = listDays[0];

            for(let i = 1; i < listDays.length; i++) {
                if(listDays[i] !== prevDay+1) {
                    isNearDays = false;
                    break;
                }
                prevDay = listDays[i];
            }

            if(isNearDays) {
                label = daysOfWeek[listDays[0]] + ' ' + t('date.to') + ' ' + daysOfWeek[listDays[listDays.length-1]];
            }
            else {
                label = listDays.map(d => daysOfWeek[d]).join(', ');
            }
        }

        return label;
    };

    const handleDeleteGroup = (event: React.MouseEvent, group: Group) => {
        event.stopPropagation();
        event.preventDefault();

        props.onDelete(group);
    };

    const handleUpdateGroup = (event: React.MouseEvent, group: Group) => {
        event.stopPropagation();
        event.preventDefault();

        props.onUpdate(group);
    };

    return (
        <div className="group-list row g-3">
            {props.product.groups.map((group: Group) => (
                <Link key={group.id} className="nostyle col-12 col-sm-6 col-md-4" to={`/m/${props.product.id}/groups/${group.id}`}>
                    <div className={`group-item gradient-color-${group.color}`}>
                        <div className="group-item-header">
                            <div className="group-item-header-name">{group.name}</div>
                            <div className="group-item-header-right">
                                {group.is_default ? (
                                    <Badge color="gray">{t('page.groups.default_group')}</Badge>
                                ) : (
                                    <>
                                        <span className="group-action" onClick={(event: React.MouseEvent) => handleUpdateGroup(event, group)}><FaPen size="0.9rem"/></span>
                                        <span className="group-action" onClick={(event: React.MouseEvent) => handleDeleteGroup(event, group)}><FaXmark size="1.2rem"/></span>
                                    </>
                                )}
                            </div>
                        </div>
                        <ul className="group-item-footer">
                            <li className="font-bold">{group.scenes.length} {group.scenes.length > 1 ? t('page.groups.scenes') : t('page.groups.scene')}</li>
                            {!group.is_default && (
                                <li>{group.all_day ? t('page.groups.input.all_day') : group.start_time + '-' + group.stop_time} ; {getRepeatLabel(group.repeat)}</li>
                            )}
                        </ul>
                    </div>
                </Link>
            ))}
        </div>
    );
}

export default GroupList;
